import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { CandidateVacanciesService } from '../../services/candidate-vacancies/candidate-vacancies.service';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule, SelectItem, DataTable } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HasPermissionService } from '../../../employee/service/has-permission/has-permission.service';
import { CustomerGuide } from '../../../employee/class/customer-guide';
import { CompanyService } from '../../../employee/service/company/company.service';
import { config } from '../../../../../environments/config';
import { Requisition } from '../../../employee/class/requisition';
import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';
import { NotificationsService } from '../../../../theme/services/notifications/notifications.service';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-candidate-vacancies',
  templateUrl: './candidate-vacancies.component.html',
  styleUrls: ['./candidate-vacancies.component.scss']
})
export class CandidateVacanciesComponent implements OnInit {
  @ViewChild('gb') searchFilter;
  @ViewChild('dt') dataTable: DataTable;

  public promiseForm: Promise<any>;

  public loading: boolean = true;
  public msgs: Message[] = [];
  public requisitions: any[];
  public RequisitionID: Number = 0;
  public showModule = true;
  public totalRecords: number;
  public page: number;
  public per_page: number;
  public filtersKanban: {key: string, value: string}[];
  public sort: string;
  public query: string;

  public filters: any[];

  public first = 0;

  public es: any;

  public confirmationDialog: boolean = false;

  public vacancie_selected: any;

  public formFilter: FormGroup;
  public applicationStatusOptions: SelectItem[];

  public salaryMinOptions: any[] = [];
  public salaryMaxOptions: any[] = [];
  public salaryMin: number = 0;
  public salaryMax: number = 15;

  // public ageMinOptions: any[] = [];
  // public ageMaxOptions: any[] = [];
  // public ageMin: number = 18;
  // public ageMax: number = 70;

  constructor(
    public candidateVacanciesService: CandidateVacanciesService,
    public confirmationService: ConfirmationService,
    private notificationsService: NotificationsService,
    public translate: TranslateService,
    public activatedRoute: ActivatedRoute,
    public hasPermissionService: HasPermissionService,
    public router: Router,
    public companyService: CompanyService,
    // public requisitionJustificationService: RequisitionJustificationService,
    // public requisitionTaskService: RequisitionTaskService,
    public fb: FormBuilder
  ) {
    this.es = calendarES();

    this.applicationStatusOptions = [
      {label: 'Todas', value: 'all'},
      {label: 'Aplicada', value: true},
      {label: 'No aplicada', value: false},
    ];

    for (let i = this.salaryMin; i <= this.salaryMax; i++)
      this.salaryMinOptions.push({ label: i.toString() + ' SMMLV', value: i });

    for (let i = this.salaryMin; i <= this.salaryMax; i++)
      this.salaryMaxOptions.push({ label: i.toString() + ' SMMLV', value: i });

    // for (let i = this.ageMin; i <= this.ageMax; i++)
    //   this.ageMinOptions.push({ label: i.toString() + ' años', value: i });

    // for (let i = this.ageMin; i <= this.ageMax; i++)
    //   this.ageMaxOptions.push({ label: i.toString() + ' años', value: i });
  }

  ngOnInit() {
    this.page = 1;
    this.per_page = 10;
    this.sort = '-id';

    this.createFormFilter();
  }

  createFormFilter(data:any = null) {
    data = data || {
      application_status: 'all',
      salary_min: '',
      salary_max: '',
      destination_id: null,
      offer_primary_area_filter: '',
      venue_id_filter: '',
      // age_min: '',
      // age_max: '',
    }

    this.formFilter = this.fb.group({
      application_status: new FormControl(data.application_status),
      salary_min: new FormControl(data.salary_min),
      salary_max: new FormControl(data.salary_max),
      destination_id: new FormControl (data.destination_id),
      offer_primary_area_filter: new FormControl(data.offer_primary_area_filter),
      venue_id_filter: new FormControl(data.venue_id_filter),

      // age_min: new FormControl(data.age_min),
      // age_max: new FormControl(data.age_max),
    });
  }

  public loadVacanciesLazy(event: LazyLoadEvent) {
    this.page = (event.first / this.per_page) + 1;

    if (event.sortOrder === -1)
      this.sort =  '-' + event.sortField;
    else
      this.sort =  event.sortField;

    if (event.globalFilter)
      this.query = event.globalFilter;
    else
      this.query = undefined;

    this.sort = '-id';

    this.getVacancies();
  }

  public filter(values) {
    this.page = 1;
    this.first = 0;

    var query = this.searchFilter.nativeElement.value;
    if (query != null && query != "")
        query = query.replace(/\s/g, "%");

    this.query = query;

    this.filters = [];

    /* if (values.status.length > 0 && values.status.indexOf('all') == '-1' && values.status.indexOf('') == '-1')
      this.filters.push({'key': 'status-in', 'value': values.status}); */

    if ( values.application_status !== null && values.application_status !== '' && values.application_status !== undefined && values.application_status !== 'all')
      this.filters.push({ 'key': 'application_status', 'value': values.application_status });

    if ( values.salary_min !== null && values.salary_min !== '' && values.salary_min !== undefined )
      this.filters.push({ 'key': 'salary-min', 'value': values.salary_min });

    if ( values.salary_max !== null && values.salary_max !== '' && values.salary_max !== undefined )
      this.filters.push({ 'key': 'salary-max', 'value': values.salary_max });

    if ( values.destination_id !== null && values.destination_id !== '' && values.destination_id !== undefined )
      this.filters.push({ 'key': 'destination_id-in', 'value': values.destination_id.id });

    if (values.offer_primary_area_filter)
      this.filters.push({'key': 'offer_primary_area_id', 'value': values.offer_primary_area_filter});

    if (values.venue_id_filter !== null && values.venue_id_filter !== '' && values.venue_id_filter !== undefined) 
      this.filters.push({'key': 'venue_id-lk', 'value': values.venue_id_filter});
      
    /* if ( values.age_min !== null && values.age_min !== '' && values.age_min !== undefined )
      this.filters.push({ 'key': 'age-min', 'value': values.age_min });

    if ( values.age_max !== null && values.age_max !== '' && values.age_max !== undefined )
      this.filters.push({ 'key': 'age-max', 'value': values.age_max }); */

    this.getVacancies();
  }

  public applyToVacancie(requisition: Requisition) {
    this.vacancie_selected = requisition;

    this.vacancie_selected.salary = this.getNumberValidation(this.vacancie_selected.salary);

    this.confirmationDialog = true;
  }

  public applyToVacancieConfirmation() {
    // alert('Excelente, has aplicado a esta vacante');
    this.putVacancie(this.vacancie_selected);
    this.confirmationDialog = false;
    this.getVacancies();
  }

  public applyToVacancieReject() {
    this.confirmationDialog = false;
  }

  public getVacancies() {
    this.loading = true;
    this.candidateVacanciesService.getVacancies(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
        response => {
            this.loading = false;
            this.requisitions = response.json().data;
            for (var i = 0; i < this.requisitions.length; i++) {
              this.requisitions[i].salary = this.getNumberValidation(this.requisitions[i].salary);
              // this.requisitions[i].range_age_min = this.getNumberValidation(this.requisitions[i].range_age_min);
              // this.requisitions[i].range_age_max = this.getNumberValidation(this.requisitions[i].range_age_max);
            }
            if (response.json().meta.total > response.json().meta.total_filtered)
              this.totalRecords = response.json().meta.total_filtered;
            else
              this.totalRecords = response.json().meta.total;
        },
        error => {
            this.loading = false;
            this.msgs = [];
            this.msgs.push( { severity: 'error', summary: 'error' } );
        }
    );
  }

  public putVacancie(values: Requisition) {
    let candidate_id = JSON.parse(localStorage.getItem('profile')).candidate_id;
    const param = {
      'requisition_id': values.id,
      'candidate_id': candidate_id,
    };
    if (values) {
      const promise = this.candidateVacanciesService.applyToVacancie(param);
      this.promiseForm = promise.toPromise().then(
        response => {
          this.translate.get('saved').subscribe((res: string) => {
            this.notificationsService.growlNotify('success', res);
            
          });
        },
        error => {
          
          const errors_body = JSON.parse(error._body);
          this.notificationsService.growlNotify('error', errors_body.error);
        }
      );
    }
  }

  public getNumberValidation(item) {
    if (isNaN(item))
      item = null;
    return item;
  }

  public updateValueMaxOptions(value_min_form: any, value_max_form: any, form_name: string, array_max_options: any[], concept: string, min_value, max_value) {
    if (value_min_form == null || value_min_form == '' || value_min_form == undefined) {
      array_max_options = [];

      for (let i = min_value; i <= max_value; i++)
        array_max_options.push({ label: i.toString() + concept, value: i });
    } else {
      array_max_options = [];

      for (let i = value_min_form; i <= max_value; i++)
        array_max_options.push({ label: i.toString() + concept, value: i });
    }

    if (value_max_form < value_min_form)
      this.formFilter.get(form_name).setValue('');

    if (form_name == 'salary_max')
      this.salaryMaxOptions = array_max_options;
    // else if (form_name == 'age_max')
    //   this.ageMaxOptions = array_max_options;
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/candidate/components/candidate-vacancies/candidate-vacancies.component.ts